import React from 'react';
import OnboardingStatusBanner from './OnboardingStatusBanner';

export default function OnboardingRegistrationStatus({
  isVerifyingActivation,
  isVerifyingEmail,
  activationError,
  showPreRegistrationGate,
  showRegistrationForm,
  isValidating,
  validationError,
  isActivated,
  successTitle = 'Registration complete',
  successDescription,
}) {
  return (
    <>
      {isVerifyingActivation && (
        <OnboardingStatusBanner
          type="loading"
          title="Verifying activation details…"
          description="Please wait while we confirm your subscription key or promo code."
        />
      )}

      {isVerifyingEmail && (
        <OnboardingStatusBanner
          type="loading"
          title="Checking email address…"
          description="Please wait while we verify this email is available for registration."
        />
      )}

      {activationError && !showPreRegistrationGate && !showRegistrationForm && (
        <OnboardingStatusBanner
          type="error"
          title="Activation could not be verified"
          description={activationError}
        />
      )}

      {isValidating && (
        <OnboardingStatusBanner
          type="loading"
          title="Validating your invitation…"
          description="We are checking that this link is still valid before opening registration."
        />
      )}

      {validationError && (
        <OnboardingStatusBanner
          type="error"
          title="This invitation link is not valid"
          description={validationError}
        />
      )}

      {isActivated && (
        <OnboardingStatusBanner
          type="success"
          title={successTitle}
          description={successDescription}
        />
      )}
    </>
  );
}
